/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'delete': {
    width: 15,
    height: 15,
    viewBox: '0 0 15 15',
    data: '<path pid="0" d="M13.27 4.038a.577.577 0 00-.578.577v8.406c0 .447-.528.825-1.154.825H3.462c-.626 0-1.154-.378-1.154-.825V4.615a.577.577 0 00-1.154 0v8.406C1.154 14.112 2.189 15 3.462 15h8.076c1.273 0 2.308-.888 2.308-1.979V4.615a.577.577 0 00-.577-.577zM14.423 2.308h-4.038V1.154C10.385.517 9.867 0 9.23 0H5.769c-.636 0-1.154.517-1.154 1.154v1.154H.577a.577.577 0 000 1.154h13.846a.577.577 0 100-1.154zm-8.654 0V1.154h3.462v1.154H5.769z" _fill="#DADADA"/><path pid="1" d="M5.192 12.692v-7.5a.577.577 0 00-1.154 0v7.5a.577.577 0 001.154 0zM8.077 12.692v-7.5a.577.577 0 00-1.154 0v7.5a.577.577 0 001.154 0zM10.962 12.788V5.192a.577.577 0 10-1.154 0v7.596a.577.577 0 101.154 0z" _fill="#DADADA"/>'
  }
})
